// extracted by mini-css-extract-plugin
module.exports = {"page":"WorksPage_page__3tntd","basic":"WorksPage_basic__2r0al"};